import { get } from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { currencyMapper } from '@nexio/emvio-util-app';

import ColorDollarAmountCell from '../../Table/Cells/ColorDollarAmountCell/ColorDollarAmountCell';
import { prettifyDate } from '../../../utils/string';
import './PayoutListItem.scss';
import { payoutProviderMapper } from '@nexio/emvio-util-app/src/mappers';

export default class PayoutListItem extends Component {
    static propTypes = {
        item: PropTypes.any,
        onGoToItem: PropTypes.func.isRequired
    };

    renderDate(date) {
        return date ? prettifyDate(date, { returnDateOnly: true }) : 'No Date';
    }

    renderProviderType(providerType) {
        return providerType ? payoutProviderMapper[providerType].toUpperCase() : '';
    }

    render() {
        const payout = this.props.item;
        const currencyCode = get(currencyMapper, payout.currencyId, '840').code;

        return (
            <div
                className="payout-list-item"
                onClick={this.props.onGoToItem}
            >
                <div className="payout-list-item-left">
                    <span className="payouts-date">
                        {this.renderDate(payout.payoutDate)}
                    </span>
                    <span className="payout-provider">
                        {this.renderProviderType(payout.providerType)}
                    </span>
                </div>
                <div className="payout-list-item-right">
                    <span className="payout-amount">
                        <ColorDollarAmountCell amount={payout.amount} currencyCode={currencyCode} />
                    </span>
                </div>
            </div>
        );
    }
}
